import { useState, useEffect } from 'react';
import colombiaMapService from '../../../services/ColombiaMapService';
import { GeoJsonFeature } from '../../../services/ColombiaMapService';

export const useUI = () => {
  const [item, setItem] = useState<GeoJsonFeature | null>(null);
  const [isListOpen, setIsListOpen] = useState(false);
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [isItemDetailOpen, setIsItemDetailOpen] = useState(false);
  const [minimizeViewMobile, setMinimizeViewMobile] = useState(false);
  const [isAdvancedFiltersExpanded, setIsAdvancedFiltersExpanded] = useState(true);
  const [hasResults, setHasResults] = useState(false);

  useEffect(() => {
    const unsubSelected = colombiaMapService.subscribeToSelectedItem((val) => {
      if (val) {
        setItem(val);
        openItemDetail();
        setMinimizeViewMobile(false);
      }
    });
    
    const unsubViewList = colombiaMapService.subscribeToViewList((flag) => {
      if (!isListOpen && !isItemDetailOpen && flag) {
        openList();
        setMinimizeViewMobile(true);
      }
    });

    const unsubFiltered = colombiaMapService.subscribeToFilteredGeoJson((data) => {
      setHasResults(data && data.features && data.features.length > 0);
    });

    return () => {
      unsubSelected?.();
      unsubViewList?.();
      unsubFiltered?.();
    };
  }, [isListOpen, isItemDetailOpen]);

  const toggleMinimizeViewMobile = () => setMinimizeViewMobile((v) => !v);
  const closeMinimizeViewMobile = () => setMinimizeViewMobile(false);

  const toggleFilter = () => {
    setIsFiltersOpen((v) => {
      if (!v) {
        setIsListOpen(false);
        setIsAdvancedFiltersExpanded(false);
      }
      return !v;
    });
  };

  const toggleAdvancedFilters = () => setIsAdvancedFiltersExpanded((v) => !v);

  const openList = () => {
    setIsFiltersOpen(false);
    setIsListOpen(true);
  };

  const closeList = () => setIsListOpen(false);

  const openItemDetail = () => { 
    setIsItemDetailOpen(true); 
    closeList(); 
  };

  const closeItemDetail = () => {
    setIsItemDetailOpen(false);
    setItem(null);
    colombiaMapService.setSelectItem(null);
    setIsFiltersOpen(true);
  };

  const goHome = () => window.location.reload();

  const setSelectedItem = (espacio: GeoJsonFeature) => {
    colombiaMapService.setSelectItem(espacio);
    openItemDetail();
  };

  return {
    item,
    isListOpen,
    isFiltersOpen,
    isItemDetailOpen,
    minimizeViewMobile,
    isAdvancedFiltersExpanded,
    hasResults,
    toggleMinimizeViewMobile,
    closeMinimizeViewMobile,
    toggleFilter,
    toggleAdvancedFilters,
    openList,
    closeList,
    openItemDetail,
    closeItemDetail,
    goHome,
    setSelectedItem,
  };
};
